import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Banner, Link } from "@shopify/polaris";
import {
  fetchMyOnboardings,
  MyOnboardingListItem,
} from "services/onboarding.service";

/**
 * Reminder that the signed-in user still has an onboarding questionnaire to
 * fill in.
 *
 * The login link drops a new hire straight onto the questionnaire, but that is
 * a one-time landing: someone who is already an employee of another company
 * signs in normally, gets the dashboard, and would otherwise have no way to
 * find the form waiting for them in the company hiring them.
 */
export default function PendingOnboardingBanner() {
  const { t } = useTranslation();
  const [onboardings, setOnboardings] = useState<MyOnboardingListItem[]>([]);

  useEffect(() => {
    let cancelled = false;
    fetchMyOnboardings()
      .then((list) => {
        if (!cancelled) setOnboardings(list || []);
      })
      // A banner is not worth surfacing an error for; the login redirect and
      // the direct link still get the employee there.
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  if (!onboardings.length) return null;

  const companies = onboardings
    .map((item) => item.company?.name)
    .filter(Boolean)
    .join(", ");

  return (
    <div className="pending-onboarding-banner">
      <Banner tone="info">
        {companies
          ? t("pending_onboarding_banner_with_company", { companies })
          : t("pending_onboarding_banner")}{" "}
        <Link url="/app/my-onboarding">{t("pending_onboarding_action")}</Link>
      </Banner>
    </div>
  );
}
